"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeCommit = exports.addNewCommit = exports.setCommitCode = exports.appendCommitCode = exports.updateCommitVariants = exports.createCommit = exports.generateCommitHash = void 0;
// Generate a unique commit hash
const generateCommitHash = () => {
    return `commit_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
};
exports.generateCommitHash = generateCommitHash;
// Create a new commit
const createCommit = (commitData) => {
    const baseCommit = {
        hash: (0, exports.generateCommitHash)(),
        parentHash: commitData.parentHash,
        dateCreated: new Date(),
        isCommitted: false,
        variants: commitData.variants || [{ code: "" }, { code: "" }],
        selectedVariantIndex: 0,
    };
    switch (commitData.type) {
        case "ai_create":
            return Object.assign(Object.assign({}, baseCommit), { type: "ai_create", inputs: { image_url: commitData.inputs.image_url } });
        case "ai_edit":
            return Object.assign(Object.assign({}, baseCommit), { type: "ai_edit", inputs: { prompt: commitData.inputs.prompt } });
        case "code_create":
            return Object.assign(Object.assign({}, baseCommit), { type: "code_create", inputs: null });
        default:
            throw new Error(`Unknown commit type: ${commitData.type}`);
    }
};
exports.createCommit = createCommit;
// Update commit variants
const updateCommitVariants = (commits, hash, updater) => {
    const commit = commits[hash];
    if (!commit) {
        throw new Error(`Commit not found: ${hash}`);
    }
    if (commit.isCommitted) {
        throw new Error("Cannot update a committed commit");
    }
    return Object.assign(Object.assign({}, commits), { [hash]: Object.assign(Object.assign({}, commit), { variants: updater(commit.variants) }) });
};
exports.updateCommitVariants = updateCommitVariants;
// Append code to a specific variant
const appendCommitCode = (commits, hash, variantIndex, code) => {
    return (0, exports.updateCommitVariants)(commits, hash, (variants) => variants.map((variant, index) => index === variantIndex
        ? Object.assign(Object.assign({}, variant), { code: variant.code + code }) : variant));
};
exports.appendCommitCode = appendCommitCode;
// Set code for a specific variant
const setCommitCode = (commits, hash, variantIndex, code) => {
    return (0, exports.updateCommitVariants)(commits, hash, (variants) => variants.map((variant, index) => index === variantIndex ? Object.assign(Object.assign({}, variant), { code }) : variant));
};
exports.setCommitCode = setCommitCode;
// Mark all commits as committed and add a new commit
const addNewCommit = (commits, newCommit) => {
    const committedCommits = Object.fromEntries(Object.entries(commits).map(([hash, commit]) => [
        hash,
        Object.assign(Object.assign({}, commit), { isCommitted: true }),
    ]));
    return Object.assign(Object.assign({}, committedCommits), { [newCommit.hash]: newCommit });
};
exports.addNewCommit = addNewCommit;
// Remove a commit
const removeCommit = (commits, hash) => {
    const newCommits = Object.assign({}, commits);
    delete newCommits[hash];
    return newCommits;
};
exports.removeCommit = removeCommit;
